import { Places } from "@/features/settings/places";

export const Route = createFileRoute({
  component: Places,
});
